import { http } from "./http";
import { Product } from "../types";

interface QuickAddProduct {
  product_id: number;
  product_name: string;
  image_url: string;
  admin_id?: number;
  created_at: string;
  updated_at: string;
}

// Fetch all Quick Add products and map to Product type
export const fetchQuickAddProducts = async (): Promise<Product[]> => {
  const response = await http.get("/quick-add");

  console.log("📢 Quick Add API Response:", response.data); // ✅ Debugging log

  return response.data.map((product: any) => ({
    id: product.id || product.product_id,
    product_id: product.product_id,
    sku: product.sku || "No SKU",
    name: product.name || product.product_name || "Unnamed Product",
    product_name: product.product_name || "Unnamed Product",
    price: product.price || 0,
    image_url: product.image_url || product.product_image || "/placeholder-image.png", // ✅ Fix here
    category_id: product.category_id || null,
    category_name: product.category_name || "Uncategorized",
    variants: product.variants || [],
  }));
};

// Add a product to Quick Add
export const addQuickAddProduct = async (productId: number): Promise<void> => {
  await http.post("/quick-add", { product_id: productId });
};

// Remove a product from Quick Add
export const removeQuickAddProduct = async (productId: number): Promise<void> => {
  await http.delete(`/quick-add/${productId}`);
};